import { styled } from "@mui/material/styles";

const styledName = "Wallets";

export const StyledContentWrapper = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    height: "calc(100% -10px)",
  },
});
